import React from 'react';
import { connect } from 'react-redux';

import LinkTab from 'retired/LinkTab';
import { selectUser, selectOrganization } from 'entities/user/selectors';
import { Features } from 'utils/features';
import type { State } from 'reducers';
import type { UserState } from 'entities/user/reducer';
import type Organization from 'entities/organization/model';
import { paymentsRouteIsEnabled } from 'containers/PaymentsRoute';
import { usePayPalVerificationEnabled } from 'containers/VerificationRoute';

import { Privileges } from '../../utils/privileges';

const OrganizationMenuInner = ({
  user,
  organization,
}: {
  user: UserState;
  organization?: Organization;
}) => {
  const payPalVerificationEnabled = usePayPalVerificationEnabled(user);
  return (
    <div>
      {user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_SETTINGS) && (
        <LinkTab
          path="/organization"
          label={organization?.isCompany() ? 'Company Profile' : 'Nonprofit Profile'}
        />
      )}
      {organization?.isCompany() && user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_SETTINGS) && (
        <LinkTab path="/app-settings" label="App Settings" />
      )}
      {(user?.isAdmin ||
        // @TODO-DP: enable for company admins once we test the feature properly
        (false &&
          organization?.isCompany() &&
          user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_SETTINGS))) && (
        <LinkTab path="/features" label="Features and Settings" />
      )}
      {(user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_ORGANIZERS) ||
        user?.hasPrivilege(Privileges.ORGANIZATION_VIEW_ORGANIZERS)) && (
        <LinkTab path="/organizers" label="Users" />
      )}
      <LinkTab path="/user" label="My Profile" />

      {paymentsRouteIsEnabled(user) && <LinkTab path="/payments" label="Payments" />}

      {payPalVerificationEnabled && <LinkTab path="/verification" label="Verification" />}

      {user?.isAdmin && user?.organization.isCompany() && (
        <LinkTab path="/locations" label="Company Locations" />
      )}
      {user?.hasFeature(Features.AUTO_SOURCE_DEEDS) &&
        user?.hasPrivilege(Privileges.AUTO_SOURCE_MANAGE) && (
          <LinkTab path="/deed-sourcing" label="Sourcing Rules" />
        )}
      {user?.isAdmin && <LinkTab path="/nonprofits-import" label="GiveIndia Import" />}

      {user?.isAdmin && user?.hasFeature(Features.PAYROLL_FLAT_FILE) && (
        <LinkTab path="/sftp-connection" label="SFTP Connection" />
      )}
    </div>
  );
};

const OrganizationMenu = ({
  user,
  organization,
}: {
  user: UserState;
  organization?: Organization;
}) => {
  if (!user) {
    return null;
  }

  return <OrganizationMenuInner user={user} organization={organization} />;
};

const withConnect = connect((state: State) => ({
  user: selectUser(state),
  organization: selectOrganization(state),
}));

export default withConnect(OrganizationMenu);
